import styled from 'styled-components';
import { LinkCell } from '@hud/web-components/Table/Table';
import { ellipsisMixin } from '@hud/web-components/theme/utils';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { RuntimeIcon } from '@hud/web-components/Runtime/RuntimeIcon';

const Name = styled(LongContentPopover)``;

const Runtime = styled(RuntimeIcon)`
  line-height: 1;
`;

const Cell = styled(LinkCell)`
  display: flex;
  gap: 8px;
  min-width: 0;
  align-items: center;
  & ${Name} {
    ${ellipsisMixin}
  }
  & ${Runtime} {
    flex-shrink: 0;
  }
`;

export default { Cell, Runtime, Name };
